module.exports = __webpack_public_path__ + "static/media/prev-arrow.dd5f232c.svg";